import { useCallback, useEffect, useState } from "react";

const storageKey = "awkwardpixels.cast-motion";

/** Honor the system default until the viewer explicitly chooses for this tab. */
export function useCastMotion() {
  const [systemReduced, setSystemReduced] = useState(() =>
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false);
  const [override, setOverride] = useState<boolean | null>(() => {
    try {
      const saved = sessionStorage.getItem(storageKey);
      // Retire the old toggle's "off" value: the notice now owns the opt-in.
      return saved === "on" ? true : null;
    } catch { return null; }
  });
  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const changed = () => setSystemReduced(query.matches);
    query.addEventListener("change", changed);
    return () => query.removeEventListener("change", changed);
  }, []);
  const setEnabled = useCallback((enabled: boolean) => {
    setOverride(enabled);
    try { sessionStorage.setItem(storageKey, enabled ? "on" : "off"); } catch { /* In-memory choice still works. */ }
  }, []);
  return { enabled: override ?? !systemReduced, disabledBySystem: override === null && systemReduced, setEnabled };
}
